export enum Routes {
  MemberHome = `^/$`,
  MemberAllBoards = `^/([^/]+)/boards$`,
  EmptySearch = `^//$`,
  Search = `^//([^/]*)`,
  Board = `^/b/([^/]+)`,
  Card = `^/c/([^/]+)`,
  Organization = `^/([^/]+)$`,
}
